import * as types from './_actionTypes';

const initialState = {
  contents: [],
  selectedContent: null,
  statistics: null,
  loading: false,
  contentsLoading: false,
  contentLoading: false,
  statsLoading: false,
  error: null,
  success: null,
   mux:{
     uploading: false,
  uploadError: null,
  uploadedVideo: null, // response from upload (e.g., playbackId, url)

  fetchingPlayback: false,
  playbackError: null,
  playbackDetails: null, // data fetched for playbackId
  },
};

const courseContentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch course contents
    case types.FETCH_COURSE_CONTENTS_REQUEST:
      return {
        ...state,
        contentsLoading: true,
        error: null
      };
    case types.FETCH_COURSE_CONTENTS_SUCCESS:
      return {
        ...state,
        contents: action.payload,
        contentsLoading: false,
        error: null
      };
    case types.FETCH_COURSE_CONTENTS_FAILURE:
      return {
        ...state,
        contentsLoading: false,
        error: action.payload
      };

    // Fetch single content
    case types.FETCH_COURSE_CONTENT_REQUEST:
      return {
        ...state,
        contentLoading: true,
        error: null
      };
    case types.FETCH_COURSE_CONTENT_SUCCESS:
      return {
        ...state,
        selectedContent: action.payload,
        contentLoading: false,
        error: null
      };
    case types.FETCH_COURSE_CONTENT_FAILURE:
      return {
        ...state,
        contentLoading: false,
        error: action.payload
      };

    // Create content
    case types.CREATE_COURSE_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    case types.CREATE_COURSE_CONTENT_SUCCESS:
      return {
        ...state,
        contents: [...state.contents, action.payload],
        loading: false,
        error: null,
        success: 'Content created successfully'
      };
    case types.CREATE_COURSE_CONTENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    // Update content
    case types.UPDATE_COURSE_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    case types.UPDATE_COURSE_CONTENT_SUCCESS:
      return {
        ...state,
        contents: state.contents.map(content =>
          content.id === action.payload.id ? action.payload : content
        ),
        selectedContent: action.payload,
        loading: false,
        error: null,
        success: 'Content updated successfully'
      };
    case types.UPDATE_COURSE_CONTENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    // Delete content
    case types.DELETE_COURSE_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    case types.DELETE_COURSE_CONTENT_SUCCESS:
      return {
        ...state,
        contents: state.contents.filter(content => content.id !== action.payload),
        selectedContent: state.selectedContent?.id === action.payload ? null : state.selectedContent,
        loading: false,
        error: null,
        success: 'Content deleted successfully'
      };
    case types.DELETE_COURSE_CONTENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    // Reorder contents
    case types.REORDER_COURSE_CONTENTS_REQUEST: {
      // Immediately update the order in the state for better UX
      const { newOrder } = action.payload;
      const updatedContents = state.contents.map(content => {
        const orderItem = newOrder.find(item => item.id === content.id);
        if (orderItem) {
          return { ...content, order_index: orderItem.order_index };
        }
        return content;
      }).sort((a, b) => a.order_index - b.order_index);
      
      return {
        ...state,
        contents: updatedContents,
        loading: true,
        error: null,
        success: null
      };
    }
    case types.REORDER_COURSE_CONTENTS_SUCCESS:
      return {
        ...state,
        contents: action.payload,
        loading: false,
        error: null,
        success: 'Content order updated successfully'
      };
    case types.REORDER_COURSE_CONTENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    // Fetch content statistics
    case types.FETCH_COURSE_CONTENT_STATS_REQUEST:
      return {
        ...state,
        statsLoading: true,
        error: null
      };
    case types.FETCH_COURSE_CONTENT_STATS_SUCCESS:
      return {
        ...state,
        statistics: action.payload,
        statsLoading: false,
        error: null
      };
    case types.FETCH_COURSE_CONTENT_STATS_FAILURE:
      return {
        ...state,
        statsLoading: false,
        error: action.payload
      };

         case types.UPLOAD_MUX_VIDEO_REQUEST:
            return {
              ...state,
              mux: {
                ...state.mux,
                uploading: true,
                uploadError: null,
                uploadedVideo: null,
              },
            };
          case types.UPLOAD_MUX_VIDEO_SUCCESS:
            return {
              ...state,
              mux: {
                ...state.mux,
                uploading: false,
                uploadedVideo: action.payload,
                uploadError: null,
              },
            };
          case types.UPLOAD_MUX_VIDEO_FAILURE:
            return {
              ...state,
              mux: {
                ...state.mux,
                uploading: false,
                uploadError: action.payload,
              },
            };
      
          // case types.FETCH_MUX_PLAYBACK_REQUEST:
          //   return {
          //     ...state,
          //     mux: {
          //       ...state.mux,
          //       fetchingPlayback: true,
          //       playbackError: null,
          //       playbackDetails: null,
          //     },
          //   };
          // case types.FETCH_MUX_PLAYBACK_SUCCESS:
          //   return {
          //     ...state,
          //     mux: {
          //       ...state.mux,
          //       fetchingPlayback: false,
          //       playbackDetails: action.payload,
          //       playbackError: null,
          //     },
          //   };
          // case types.FETCH_MUX_PLAYBACK_FAILURE:
          //   return {
          //     ...state,
          //     mux: {
          //       ...state.mux,
          //       fetchingPlayback: false,
          //       playbackError: action.payload,
          //     },
          //   };
    // Utility actions
    case types.CLEAR_COURSE_CONTENT_ERROR:
      return {
        ...state,
        error: null,
        success: null
      };
    case types.RESET_COURSE_CONTENT_STATE:
      return initialState;

    default:
      return state;
  }
};

export default courseContentReducer;






















